console.log(`${process.env.PACKAGE_VERSION}, ${process.env.BUILD_DATE}`);

// shared scripts
export * from "../../shared/scripts/login";
export * from "../../shared/scripts/rewards";
export * from "../../shared/scripts/stripe";
export * from "../../shared/scripts/offer";
